import React from 'react';
import { Project } from '../../../lib/types';
import { Input } from '../../../components/ui/Input';
import { Select } from '../../../components/ui/Select';
import { Textarea } from '../../../components/ui/Textarea';
interface DesignTabProps {
  project: Project;
  updateField: (field: keyof Project, value: any) => void;
}
export function DesignTab({
  project,
  updateField
}: DesignTabProps) {
  return <div className="space-y-12 pb-24 max-w-3xl" data-id="element-1053">
      <section className="space-y-6" data-id="element-1054">
        <div className="border-b border-border pb-2" data-id="element-1055">
          <h2 className="font-display text-2xl font-bold" data-id="element-1056">Project Theme</h2>
          <p className="font-mono text-xs text-muted-foreground mt-1" data-id="element-1057">
            Override global design settings for this specific case study.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1058">
          <Select label="Hero Style" value={project.heroStyle} onChange={e => updateField('heroStyle', e.target.value)} options={[{
          label: 'Default (Left Aligned)',
          value: 'default'
        }, {
          label: 'Centered',
          value: 'centered'
        }, {
          label: 'Split (Text / Image)',
          value: 'split'
        }]} data-id="element-1059" />

          <Select label="Section Spacing" value={project.sectionSpacing} onChange={e => updateField('sectionSpacing', e.target.value)} options={[{
          label: 'Small (Compact)',
          value: 'small'
        }, {
          label: 'Medium (Default)',
          value: 'medium'
        }, {
          label: 'Large (Airy)',
          value: 'large'
        }]} data-id="element-1060" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1061">
          <div data-id="element-1062">
            <label className="font-mono text-xs text-muted-foreground uppercase tracking-widest mb-1.5 block" data-id="element-1063">
              Accent Color
            </label>
            <div className="flex gap-2" data-id="element-1064">
              <input type="color" value={project.accentColor.startsWith('hsl') ? '#ccff00' : project.accentColor} // Simplified for demo
            onChange={e => updateField('accentColor', e.target.value)} className="w-10 h-10 p-1 bg-background border border-border cursor-pointer" data-id="element-1065" />
              <Input value={project.accentColor} onChange={e => updateField('accentColor', e.target.value)} className="flex-1" data-id="element-1066" />
            </div>
          </div>

          <div data-id="element-1067">
            <label className="font-mono text-xs text-muted-foreground uppercase tracking-widest mb-1.5 block" data-id="element-1068">
              Background Color
            </label>
            <div className="flex gap-2" data-id="element-1069">
              <input type="color" value={project.backgroundColor.startsWith('hsl') ? '#0f0f0f' : project.backgroundColor} onChange={e => updateField('backgroundColor', e.target.value)} className="w-10 h-10 p-1 bg-background border border-border cursor-pointer" data-id="element-1070" />
              <Input value={project.backgroundColor} onChange={e => updateField('backgroundColor', e.target.value)} className="flex-1" data-id="element-1071" />
            </div>
          </div>

          <div data-id="element-1072">
            <label className="font-mono text-xs text-muted-foreground uppercase tracking-widest mb-1.5 block" data-id="element-1073">
              Text Color
            </label>
            <div className="flex gap-2" data-id="element-1074">
              <input type="color" value={project.textColor.startsWith('hsl') ? '#ebebeb' : project.textColor} onChange={e => updateField('textColor', e.target.value)} className="w-10 h-10 p-1 bg-background border border-border cursor-pointer" data-id="element-1075" />
              <Input value={project.textColor} onChange={e => updateField('textColor', e.target.value)} className="flex-1" data-id="element-1076" />
            </div>
          </div>
        </div>
      </section>

      <section className="space-y-6" data-id="element-1077">
        <div className="border-b border-border pb-2" data-id="element-1078">
          <h2 className="font-display text-2xl font-bold" data-id="element-1079">Media</h2>
          <p className="font-mono text-xs text-muted-foreground mt-1" data-id="element-1080">
            Cover images and thumbnails.
          </p>
        </div>

        <Input label="Cover Image URL" value={project.coverImage} onChange={e => updateField('coverImage', e.target.value)} placeholder="https://..." data-id="element-1081" />

        {project.coverImage && <div className="mt-4 border border-border p-2 bg-card" data-id="element-1082">
            <img src={project.coverImage} alt="Cover preview" className="w-full h-48 object-cover" data-id="element-1083" />
          </div>}
      </section>

      <section className="space-y-6" data-id="element-1084">
        <div className="border-b border-border pb-2" data-id="element-1085">
          <h2 className="font-display text-2xl font-bold" data-id="element-1086">Advanced</h2>
          <p className="font-mono text-xs text-muted-foreground mt-1" data-id="element-1087">
            Custom CSS for this specific project page.
          </p>
        </div>

        <Textarea label="Custom CSS" value={project.customCSS} onChange={e => updateField('customCSS', e.target.value)} placeholder=".project-hero { ... }" rows={8} className="font-mono text-xs" data-id="element-1088" />
      </section>
    </div>;
}